import { Alert } from "react-bootstrap";
import { DatasetParsingState } from "../../api/Datasets";
import { LucideIcon } from "../../common/icon/LucideIcon";

export const errorMSG = (error: string, type: string = "danger") => {
  return <Alert bsStyle={type}>{error}</Alert>;
};

export const RenderParsingState = ({ state }: { state: DatasetParsingState }) => {
  switch (state) {
    case "NotParsable":
      return (
        <label className="label label-soft-info" style={{ margin: 0 }}>
          <LucideIcon name="x" /> Not parsable
        </label>
      );
    case "NotYetParsed":
      return (
        <label className="label label-soft-warning" style={{ margin: 0 }}>
          <LucideIcon name="clock" /> Not yet parsed
        </label>
      );
    case "ParsedSuccessfully":
      return (
        <label className="label label-soft-success" style={{ margin: 0 }}>
          <LucideIcon name="check" /> Parsed successfully
        </label>
      );
    case "ParsingFailed":
      return (
        <label className="label label-soft-warning" style={{ margin: 0 }}>
          <LucideIcon name="triangle-alert" /> Parsing failed
        </label>
      );
    default:
      return (
        <label className="label label-soft-warning" style={{ margin: 0 }}>
          <LucideIcon name="ban" /> Unknown
        </label>
      );
  }
};
